export const EXTRA_GRANT_PERIOD_MONTHLY = "monthly";
export const EXTRA_GRANT_PERIOD_MONTHLY_LABEL = "Mensual";
export const EXTRA_GRANT_PERIOD_YEARLY = "yearly";
export const EXTRA_GRANT_PERIOD_YEARLY_LABEL = "Anual";

export const EXTRA_GRANT_PERIOD_CHOICES: Map<string, string> = new Map([
  [EXTRA_GRANT_PERIOD_MONTHLY, EXTRA_GRANT_PERIOD_MONTHLY_LABEL],
  [EXTRA_GRANT_PERIOD_YEARLY, EXTRA_GRANT_PERIOD_YEARLY_LABEL],
]);

export interface ExtraGrantCreatedByUser {
  id: number;
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
}

interface TaxPayerElectronicDocumentExtraGrant {
  id?: number;
  taxPayerId?: number;
  periodType?: string;
  year?: number;
  month?: number | null;
  extraDesAmount?: number;
  extraReceiptsAmount?: number;
  isActive?: boolean;
  note?: string | null;
  createdByUserId?: number | null;
  createdByUser?: ExtraGrantCreatedByUser | null;
  createdAt?: string;
  updatedAt?: string;
}

export default TaxPayerElectronicDocumentExtraGrant;
